import StyledInput from 'components/styledInput/StyledInput';

const PrerequisitesSection = ({
  materials,
  updateMaterials,
  permits,
  updatePermits,
  languages,
  updateLanguages,
  setDataCreateMission,
}) => {
  const onMaterialsChange = (updated) => {
    const normalized = updated.map((u) => ({
      name: u.value,
      checked: u.checked,
    }));
    updateMaterials(normalized);
    setDataCreateMission((prev) => ({
      ...prev,
      tools: updated.filter((u) => u.checked).map((u) => u.value),
    }));
  };

  const onPermitsChange = (updated) => {
    const normalized = updated.map((u) => ({
      name: u.value,
      checked: u.checked,
    }));
    updatePermits(normalized);
    setDataCreateMission((prev) => ({
      ...prev,
      licences: updated.filter((u) => u.checked).map((u) => u.value),
    }));
  };

  const onLanguagesChange = (updated) => {
    const normalized = updated.map((u) => ({
      name: u.value,
      checked: u.checked,
    }));
    updateLanguages(normalized);
    setDataCreateMission((prev) => ({
      ...prev,
      languages: updated.filter((u) => u.checked).map((u) => u.value),
    }));
  };

  return (
    <div className="flex flex-col gap-4">
      <div className="text-xl">Pré-requis</div>
      <StyledInput
        type="selectMultipleCheckbox"
        isSearchable
        label="Matériel nécessaire"
        value={
          materials.filter((m) => m.checked).length > 0
            ? materials
                .filter((m) => m.checked)
                .map((m) => m.name)
                .join(', ')
            : '-'
        }
        list={materials.map((m) => ({
          value: m.name,
          label: m.name,
          checked: m.checked,
        }))}
        onChange={onMaterialsChange}
      />
      <StyledInput
        type="selectMultipleCheckbox"
        isSearchable
        label="Permis nécessaire"
        value={
          permits.filter((p) => p.checked).length > 0
            ? permits
                .filter((p) => p.checked)
                .map((p) => p.name)
                .join(', ')
            : '-'
        }
        list={permits.map((p) => ({
          value: p.name,
          label: p.name,
          checked: p.checked,
        }))}
        onChange={onPermitsChange}
      />
      <StyledInput
        type="selectMultipleCheckbox"
        isSearchable
        label="Langue nécessaire"
        value={
          languages.filter((l) => l.checked).length > 0
            ? languages
                .filter((l) => l.checked)
                .map((l) => l.name)
                .join(', ')
            : '-'
        }
        list={languages.map((l) => ({
          value: l.name,
          label: l.name,
          checked: l.checked,
        }))}
        onChange={onLanguagesChange}
      />
    </div>
  );
};

export default PrerequisitesSection;
